<script>
import api from '@/services/api'
import auth from '@/services/auth'
import _ from 'lodash'

export default {
  name: 'Api',
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    orderBy: {
      type: String,
      default: ''
    },
    orderAsc: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      entities: null,
      isSingle: false,
      config: {
        'headers': {
          'Accept': 'application/json'
        }
      },
      pagination: {
        from: 0,
        to: 0,
        total: 0,
        per_page: 20,
        current_page: 0,
        last_page: 1
      },
      search: {},
      error: null,
      isLoading: false,
      filters: {},
      locales: {}
    }
  },
  watch: {
    filters: {
      handler: function() { this.fetch(this.model) },
      deep: true
    }
  },
  async created() {
    const vm = this
    vm.loading = true
    if(!vm.isAuthenticated){
      await vm.login()
    }
  },
  methods: {
    async fetch(model, id = null, page = 1, per_page = 20, laterFilters = {}) {
      const vm = this
      vm.isLoading = true
      await api.fetch(model || vm.model, id, {
        params: this.getParams(_.extend({ page: page, per_page: per_page }, laterFilters))
      }).then(response => {
        if(response.success === false) {
          vm.handleError(response)
        }
        if(response.data && response.data.length > 0) {
          vm.entities = response.data
          vm.pagination = _.pick(response, _.keys(vm.pagination))
        }
        vm.isLoading = false
      }).catch(function (error) {
        console.log('[catch error]', error)
        return {success: false, data: error}
      })
    },
    sort(field) {
      if (field == this.orderBy) {
        this.orderAsc = !this.orderAsc
      } else {
        this.orderBy = field
        this.orderAsc = true
      }
      this.fetch(this.model, null, this.pagination.current_page, this.pagination.per_page)
    },
    filterSearch(model, searchform) {
      this.search = searchform
      this.filters = searchform
      this.fetch(model)
    },
    getParams(filters = {}) {
      return _.extend(this.params, {
          order_by: this.orderBy,
          order: (this.orderAsc) ? 'asc' : 'desc',
          search: this.search.full_text || null
        }, this.filters, filters)
    },
    getLocales() {
      const vm = this
      vm.isLoading = true
    },
    /** 
      * Simple Get Call 
    */
    async get(url, params = []) {
      const vm = this
      vm.isLoading = true
      return await api.fetch(url, null, {params: params}).then(response => {
        vm.isLoading = false
        return response
      }).catch(function (error) {
        console.log('[catch error]', error)
        return {success: false, data: error}
      });
    },
    handleError(error){
      //console.log('[handleError]', error)
      switch(error){
        case 'unauthorized': this.login(); break;
      }
    },
    async login(){
      const vm = this
      try {
        if(process.env.VUE_APP_API_USERNAME && process.env.VUE_APP_API_PASSWORD){
          await auth.login({
            email: process.env.VUE_APP_API_USERNAME, 
            password: process.env.VUE_APP_API_PASSWORD,
            auto: true
          }).then(response => {
            if(response.success) {
              vm.$router.go() // reload page after login
            }else{
              vm.error = response.message || response.data
              vm.status = response.data.status || null
              vm.showError = true
            }
          })
        } else {
          alert('NO API CREDENTIALS')
        }
      } catch (error){
        vm.error = error
        vm.showError = true
        vm.submitting = false
      }
    }
  }
}
</script>
